import { render, staticRenderFns } from "./AdminCalendarEventForm.vue?vue&type=template&id=848515e8&"
import script from "./AdminCalendarEventForm.vue?vue&type=script&lang=js&"
export * from "./AdminCalendarEventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports